/*
  TPL PhotoSwipe v5 lightbox — 2026-04-19 rewrite.
  Intercepts product image clicks, opens a fullscreen pan/pinch/swipe gallery.

  Bundler bypass:
    Shopify's asset pipeline rewrites `import(url)` into `require(url)` which
    throws at runtime. We dodge this by constructing the dynamic import
    through the Function constructor — esbuild can't parse into Function
    bodies, so the real runtime `import()` survives.
*/

(function () {
  var PSWP_CSS = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.css';
  var PSWP_MODULE = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.esm.min.js';

  // Build a real dynamic importer at runtime — bundler can't see inside this.
  var dynImport = new Function('u', 'return import(u)');

  var _pswpPromise = null;
  function loadPhotoSwipe() {
    if (_pswpPromise) return _pswpPromise;
    _pswpPromise = dynImport(PSWP_MODULE)
      .then(function (mod) { return mod && mod.default ? mod.default : mod; })
      .catch(function (err) {
        _pswpPromise = null;
        throw err;
      });
    return _pswpPromise;
  }

  function ensureCss() {
    if (!document.querySelector('link[data-pswp-css]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = PSWP_CSS;
      link.setAttribute('data-pswp-css', '');
      document.head.appendChild(link);
    }
    // Theme overrides — must come AFTER PhotoSwipe CSS in the cascade.
    if (!document.querySelector('link[data-pswp-theme]')) {
      var themeUrl = document.querySelector('script[src*="tpl-photoswipe.js"]');
      if (themeUrl) {
        var base = themeUrl.src.replace(/tpl-photoswipe\.js.*$/, 'tpl-photoswipe.css');
        var tlink = document.createElement('link');
        tlink.rel = 'stylesheet';
        tlink.href = base;
        tlink.setAttribute('data-pswp-theme', '');
        document.head.appendChild(tlink);
      }
    }
  }

  function upscaleShopifyImage(src, targetW) {
    if (!src) return src;
    // Shopify image URLs support width transform via `_NNNNx` filename suffix
    // or `?width=NNN` query param. Swap to a bigger size for the lightbox.
    /* TPL 2026-05-10: 3000w (was 2000w) so retina pinch-zoom stays crisp on
       iPhone 14 Pro (390×3 dpr = 1170 device px). 2000w gave only ~1.7x
       headroom for zoom — print details looked soft. Shopify CDN supports
       up to 5760w; 3000w is the balance between quality and weight. */
    var w = targetW || 3000;
    if (/_\d+x(\d+)?\./.test(src)) {
      return src.replace(/_\d+x(\d+)?\./, '_' + w + 'x.');
    }
    if (/[?&]width=\d+/.test(src)) {
      return src.replace(/([?&])width=\d+/, '$1width=' + w);
    }
    if (/\.(jpg|jpeg|png|webp)(\?|$)/i.test(src)) {
      return src.indexOf('?') === -1
        ? src + '?width=' + w
        : src + '&width=' + w;
    }
    return src;
  }

  function getMediaList() {
    /* TPL 2026-05-10: query modal-content FIRST. The gallery <li> wrappers
       have section-id-prefixed mediaIds (e.g. "template--19697__main-28620…")
       that don't match the bare numeric ids on click targets, so resolving
       a clicked mediaId to an index would fail. Modal-content has bare ids,
       deduped and ordered the same way the gallery does — perfect source. */
    var list =
      document.querySelector('.product-media-modal__content') ||
      document.querySelector('product-modal') ||
      document.querySelector('media-gallery [role="list"]');
    if (!list) return [];

    var items = [];
    var seen = {};

    function escAttr(v) {
      return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }

    list.querySelectorAll('[data-media-id]').forEach(function (wrapper) {
      var mediaId = wrapper.getAttribute('data-media-id');
      if (!mediaId || seen[mediaId]) return;

      /* TPL 2026-05-11: native videos are now FIRST-CLASS PhotoSwipe slides
         using PhotoSwipe v5's HTML content type. Customers can swipe between
         images and the video without the lightbox closing. Video clicks
         elsewhere route here too (no separate product-modal flow on touch). */
      if (wrapper.classList && wrapper.classList.contains('tpl-pdp-video')) {
        var videoEl = wrapper.querySelector('video');
        if (!videoEl) return;
        var srcs = [];
        var directSrc = videoEl.getAttribute('src');
        if (directSrc) srcs.push({ src: directSrc, type: '' });
        Array.prototype.forEach.call(videoEl.querySelectorAll('source'), function (s) {
          srcs.push({ src: s.getAttribute('src') || s.src, type: s.getAttribute('type') || '' });
        });
        if (!srcs.length) return;
        var posterImg = wrapper.querySelector('img');
        var posterSrc = posterImg ? (posterImg.currentSrc || posterImg.src || '') : '';
        var vw = videoEl.videoWidth || parseInt(videoEl.getAttribute('width'), 10) || 1920;
        var vh = videoEl.videoHeight || parseInt(videoEl.getAttribute('height'), 10) || 1080;
        var sourceTags = srcs.map(function (s) {
          return '<source src="' + escAttr(s.src) + '"' +
            (s.type ? ' type="' + escAttr(s.type) + '"' : '') + '>';
        }).join('');
        var html =
          '<div class="tpl-pswp-video-slide" data-media-id="' + escAttr(mediaId) + '">' +
            '<video controls playsinline preload="metadata"' +
            (posterSrc ? ' poster="' + escAttr(posterSrc) + '"' : '') + '>' +
              sourceTags +
            '</video>' +
          '</div>';
        seen[mediaId] = true;
        items.push({
          type: 'html',
          html: html,
          width: vw,
          height: vh,
          mediaId: mediaId,
          isVideo: true
        });
        return;
      }

      /* External video (YouTube/Vimeo) and 3D model still fall back to native
         product-modal — PhotoSwipe HTML slides can't reliably autoplay
         third-party iframes on iOS, and 3D models need <model-viewer>. */
      if (wrapper.classList && (
        wrapper.classList.contains('deferred-media') ||
        wrapper.classList.contains('product-media-modal__model')
      )) return;

      /* Image: wrapper is the <img> itself in modal (Dawn pattern). */
      var img = wrapper.tagName === 'IMG'
        ? wrapper
        : wrapper.querySelector('img[src], img[srcset]');
      if (!img) return;

      var src = img.currentSrc || img.src;
      var fullSrc = upscaleShopifyImage(src, 2000);
      var w = img.naturalWidth || parseInt(img.getAttribute('width'), 10) || 2000;
      var h = img.naturalHeight || parseInt(img.getAttribute('height'), 10) || 2000;

      seen[mediaId] = true;
      /* Shared transition (motion.dev port, 2026-09-08): hand PhotoSwipe the
         visible gallery image so the zoom starts from its real bounds. */
      var thumbEl = document.querySelector('.product__media-list img[data-media-id="' + mediaId + '"]') ||
        document.querySelector('.product__media-item[data-media-id$="-' + mediaId + '"] img');
      items.push({
        src: fullSrc,
        width: w,
        height: h,
        alt: img.alt || '',
        mediaId: mediaId,
        element: thumbEl || undefined,
      });
    });
    return items;
  }

  function openAt(index, items, opener) {
    ensureCss();
    /* TPL 2026-05-10: pause any playing media (autoplay PDP video, deferred
       videos in modals) before opening the lightbox so audio can't bleed. */
    if (typeof window.pauseAllMedia === 'function') {
      try { window.pauseAllMedia(); } catch (e) { /* defensive */ }
    }
    /* Honour reduced-motion: skip the zoom animation for users who request it. */
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    return loadPhotoSwipe().then(function (PhotoSwipe) {
      var pswp = new PhotoSwipe({
        dataSource: items,
        index: Math.max(0, index),
        bgOpacity: 0.94,
        showHideAnimationType: reducedMotion ? 'none' : 'zoom',
        showAnimationDuration: reducedMotion ? 0 : 280,
        hideAnimationDuration: reducedMotion ? 0 : 220,
        // Touch gestures
        pinchToClose: true,
        closeOnVerticalDrag: true,
        wheelToZoom: true,
        // Tap to toggle UI, double-tap to zoom — both on by default.
        // Counter lives in the toolbar.
        allowPanToNext: true,
        /* TPL 2026-05-10: enable cycling when there's only one image so the
           prev/next arrows don't render as dead UI. Multi-image keeps loop:false
           so users hit a clear start/end. */
        loop: items.length <= 1,
      });

      /* ── A11y wiring (TPL 2026-05-10) ── */
      pswp.on('uiRegister', function () {
        /* Single-image gallery — hide nav arrows via CSS hook. */
        if (items.length <= 1 && pswp.element) {
          pswp.element.classList.add('pswp--one-slide');
        }
        /* Aria-label + 44×44 tap target for the close button. PhotoSwipe v5 ships
           an SVG-only button with no label by default. */
        var closeBtn = pswp.element && pswp.element.querySelector('.pswp__button--close');
        if (closeBtn) {
          closeBtn.setAttribute('aria-label', 'Close gallery');
        }
        /* Live region so screen readers hear "Image N of M" on slide change.
           PhotoSwipe's counter is visible-only by default. */
        if (pswp.element && !pswp.element.querySelector('.tpl-pswp-live')) {
          var live = document.createElement('div');
          live.className = 'tpl-pswp-live visually-hidden';
          live.setAttribute('role', 'status');
          live.setAttribute('aria-live', 'polite');
          live.setAttribute('aria-atomic', 'true');
          live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);';
          pswp.element.appendChild(live);
          pswp.__tplLive = live;
        }
        /* Mark the root as a dialog so AT users know it's modal. */
        if (pswp.element) {
          pswp.element.setAttribute('role', 'dialog');
          pswp.element.setAttribute('aria-modal', 'true');
          pswp.element.setAttribute('aria-label', 'Image gallery');
        }
        /* TPL 2026-09-07: "Collector photo" pill inside the lightbox. Slides
           whose alt starts with "Collector photo" (review photos uploaded as
           product media) get the same pill as the gallery, anchored to the
           bottom-left of the rendered image and re-placed on every pan/zoom. */
        if (pswp.element && !pswp.element.querySelector('.tpl-media-badge')) {
          var badge = document.createElement('span');
          badge.className = 'tpl-media-badge';
          badge.setAttribute('aria-hidden', 'true');
          badge.textContent = 'Collector photo';
          badge.hidden = true;
          pswp.element.appendChild(badge);
          var placeBadge = function () {
            var slide = pswp.currSlide;
            var alt = slide && slide.data && slide.data.alt ? String(slide.data.alt) : '';
            if (!slide || alt.indexOf('Collector photo') !== 0) { badge.hidden = true; return; }
            var zoom = slide.currZoomLevel || 1;
            var h = (slide.height || 0) * zoom;
            var x = (slide.pan && slide.pan.x) || 0;
            var y = (slide.pan && slide.pan.y) || 0;
            badge.hidden = false;
            badge.style.left = Math.round(x + 14) + 'px';
            badge.style.top = Math.round(y + h - 14 - badge.offsetHeight) + 'px';
          };
          pswp.on('change', function () { window.requestAnimationFrame(placeBadge); });
          pswp.on('zoomPanUpdate', placeBadge);
          pswp.on('afterInit', placeBadge);
          pswp.on('resize', function () { window.requestAnimationFrame(placeBadge); });
        }
      });

      pswp.on('change', function () {
        /* Pause every video in the lightbox so audio doesn't bleed across
           slides as the user swipes. The user has to tap play again on the
           new video — that matches PhotoSwipe's "controls available, no
           auto-play" expectation for embedded media. */
        if (pswp.element) {
          Array.prototype.forEach.call(
            pswp.element.querySelectorAll('.tpl-pswp-video-slide video'),
            function (v) { try { v.pause(); } catch (e) {} }
          );
        }
        if (pswp.__tplLive && pswp.currIndex !== undefined) {
          var currItem = items[pswp.currIndex] || {};
          var label = currItem.isVideo ? 'Video' : 'Image';
          pswp.__tplLive.textContent =
            label + ' ' + (pswp.currIndex + 1) + ' of ' + items.length;
        }
      });

      /* ── Cleanup + focus restore on close (TPL 2026-05-10) ── */
      pswp.on('close', function () {
        if (opener && typeof opener.focus === 'function') {
          try { opener.focus({ preventScroll: true }); } catch (e) {}
        }
      });
      pswp.on('destroy', function () {
        /* Defensive — instance is being torn down, drop any custom refs. */
        pswp.__tplLive = null;
      });
      /* PhotoSwipe v5 auto-destroys on close, but call explicitly so any
         retained DOM nodes are GC'd promptly. */
      pswp.on('afterClose', function () {
        try { pswp.destroy(); } catch (e) {}
      });

      pswp.init();
      return pswp;
    });
  }

  function handleClick(e) {
    if (!e.target || !e.target.closest) return;

    /* Match three trigger surfaces:
         - image media wrapper (Dawn's modal-opener)
         - native autoplay video tile in the gallery
         - the modal-opener carrying class --video (would be hidden by our CSS
           when .tpl-pdp-video is present, but we keep it as a click target on
           browsers without :has() support).
       Skip --external_video and --model — those still use native modal. */
    var imgOpener = e.target.closest('.product__modal-opener--image');
    var videoTile = e.target.closest('.tpl-pdp-video');
    var videoOpener = e.target.closest('.product__modal-opener--video');
    var trigger = imgOpener || videoTile || videoOpener;
    if (!trigger) return;

    var items = getMediaList();
    if (!items.length) return; // let the native fallback handle it

    /* Resolve mediaId from whichever trigger we matched. */
    var mediaId = null;
    var focusTarget = null;
    if (imgOpener) {
      var btn = imgOpener.querySelector('.product__media-toggle[data-media-id]');
      mediaId = btn ? btn.getAttribute('data-media-id') : null;
      focusTarget = btn || imgOpener;
    } else if (videoTile) {
      mediaId = videoTile.getAttribute('data-media-id');
      focusTarget = videoTile;
    } else if (videoOpener) {
      var vbtn = videoOpener.querySelector('.product__media-toggle[data-media-id]');
      mediaId = vbtn ? vbtn.getAttribute('data-media-id') : null;
      focusTarget = vbtn || videoOpener;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    var index = 0;
    if (mediaId) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].mediaId === mediaId) { index = i; break; }
      }
    }

    openAt(index, items, focusTarget).catch(function (err) {
      if (window.console && console.warn) console.warn('[tpl-photoswipe] fallback to native modal:', err);
      var fallbackOpener = imgOpener || videoOpener;
      if (!fallbackOpener) return;
      var modalAttr = fallbackOpener.getAttribute('data-modal');
      if (modalAttr) {
        var modal = document.querySelector(modalAttr);
        if (modal && typeof modal.show === 'function') modal.show(fallbackOpener);
      }
    });
  }

  // Desktop (hover-capable, fine pointer): no modal on click, just a
  // cursor-tracked hover zoom that mirrors the homepage product grid
  // (see initPanZoom in tpl-animations.js). We:
  //   1. swallow any click bubbling out of <modal-opener> so neither
  //      Dawn's native modal nor PhotoSwipe fire
  //   2. attach mouseenter/mousemove/mouseleave to each modal-opener and
  //      drive transform + transform-origin on the inner img
  function suppressClick(e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.product__modal-opener--image')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  var DESKTOP_PAN_SCALE = 1.6;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function panImagesIn(opener) {
    if (reducedMotion.matches) return;
    opener.querySelectorAll('img').forEach(function (img) {
      img.style.transform = 'scale(' + DESKTOP_PAN_SCALE + ')';
    });
  }

  function panImagesMove(opener, e) {
    if (reducedMotion.matches) return;
    var rect = opener.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    opener.querySelectorAll('img').forEach(function (img) {
      img.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  function panImagesOut(opener) {
    opener.querySelectorAll('img').forEach(function (img) {
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = 'center center';
    });
  }

  var hoverPanBound = false;
  function bindHoverPan() {
    if (hoverPanBound) return;
    hoverPanBound = true;

    function attachToOpener(opener) {
      if (opener.__tplHoverPan) return;
      opener.__tplHoverPan = true;
      opener.addEventListener('mouseenter', function () { panImagesIn(opener); });
      opener.addEventListener('mousemove', function (e) { panImagesMove(opener, e); }, { passive: true });
      opener.addEventListener('mouseleave', function () { panImagesOut(opener); });
    }

    function scan() {
      document.querySelectorAll('.product__modal-opener--image').forEach(attachToOpener);
    }

    scan();
    // Variant swap can re-render the gallery — re-scan on Dawn's section render.
    document.addEventListener('shopify:section:load', scan);
    // Also catch dynamic media swaps (Dawn's media-gallery setActiveMedia).
    var mo = new MutationObserver(scan);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function unbindHoverPan() {
    // Cheap path: leave listeners attached but reset any inline transform.
    document.querySelectorAll('.product__modal-opener--image').forEach(panImagesOut);
  }

  // Touch-only gating: lightbox is mobile/tablet behaviour.
  // Re-evaluate on mql change so convertibles flip correctly.
  /* TPL 2026-05-10: require BOTH (hover: none) AND (pointer: coarse) so hybrid
     devices (iPad with mouse, Surface, Android with mouse) which match
     (hover: none) but have a precise pointer use the desktop hover-zoom flow
     instead of the touch lightbox. Pure touch devices (iPhone, Android phone,
     fingertip-only iPad) match both. */
  var touchMql = window.matchMedia('(hover: none) and (pointer: coarse)');
  var lightboxAttached = false;
  var suppressAttached = false;

  function syncListeners(e) {
    var isTouch = (e && typeof e.matches === 'boolean') ? e.matches : touchMql.matches;
    if (isTouch) {
      if (suppressAttached) {
        document.removeEventListener('click', suppressClick, true);
        suppressAttached = false;
      }
      if (!lightboxAttached) {
        // Capture phase so we run before Dawn's <modal-opener>.
        document.addEventListener('click', handleClick, true);
        lightboxAttached = true;
      }
    } else {
      if (lightboxAttached) {
        document.removeEventListener('click', handleClick, true);
        lightboxAttached = false;
      }
      if (!suppressAttached) {
        document.addEventListener('click', suppressClick, true);
        suppressAttached = true;
      }
      // Desktop only — wire cursor-tracked hover zoom on every modal-opener.
      bindHoverPan();
    }
  }

  syncListeners();
  if (typeof touchMql.addEventListener === 'function') {
    touchMql.addEventListener('change', syncListeners);
  } else if (typeof touchMql.addListener === 'function') {
    touchMql.addListener(syncListeners); // Safari < 14 fallback
  }
})();
